import { Box, Button, IconButton, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { AddCircleOutline, ArrowBack, ArrowForward, Campaign, ContentCopy, Delete, Edit, FilterAlt, Loop, North, Send, South } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Announcements, UserType } from "../../Types/UnitFeatureTypes";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FIXED_PAGE_ROWS } from "../../Utils/Constants";
import { Actions, RootState } from "../../Redux/Reducer/rootReducer";
import { fetchAnnouncement, fetchAnnouncementCount } from "../../Redux/selectors";
import WarningDialog from "../CommonComponents/WarningDialog";
import BuildAnnouncementTable from "../BuildTables/BuildAnnouncementTable";
import { useAuth } from "../../context/authContext";
import LoadingOverlay from "../CommonComponents/LoadingOverlay";
import DropdownSelection from "../CommonComponents/DropdownSelection";
import SortComponent from "../CommonComponents/SortComponent";
import PageNavigation from "../CommonComponents/PageNavigation";
import ViewTableHeader from "../CommonComponents/ViewTableHeader";

const ViewAnnouncementTable: React.FC = () => {

    const navigate = useNavigate();
    const [sortDirection, setSortDirection] = useState<boolean>(false);
    const [sortColumn, setSortColumn] = useState<string>('created_on');
    const allAnnouncements = useSelector(fetchAnnouncement) as Announcements[];
    const allAnnouncementsCount = useSelector(fetchAnnouncementCount) as string;
    const [deleteAnnouncementId, setDeleteAnnouncementId] = useState<number>(-1);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [item, setItem] = useState<Announcements[]>([]);
    const isLoading = useSelector((state: RootState) => state.fetchAnnouncement.request.loading);
    const dispatch = useDispatch();
    const { user} = useAuth();
    const IS_MANAGER = user?.type === UserType.MANAGER;

    useEffect(() => {
        dispatch(Actions.fetchAnnouncement.announcementActions.request({offset: (currentPage)*FIXED_PAGE_ROWS, sortColumn, sortDirection: sortDirection ? 'asc' : 'desc'}));
    },[currentPage, allAnnouncementsCount, sortColumn, sortDirection]);

    useEffect(() => {
        setCurrentPage(0)
    }, [sortDirection]);

    useEffect(() => {
        setItem(allAnnouncements);
    }, [allAnnouncements]);

    useEffect(() => {
        const totalRequest = Number(allAnnouncementsCount);
        const pages = Math.ceil(totalRequest/FIXED_PAGE_ROWS);
        setTotalPages(pages);
    }, [allAnnouncementsCount]);

    const handleAddAnnouncement = (event: React.MouseEvent<HTMLButtonElement>) => {
        navigate('/createAnnouncement');
    }

    return (
        <>
        <LoadingOverlay isLoading={isLoading} />
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            <ViewTableHeader
                title="Announcements"
                icon={Campaign}
                handleAdd={handleAddAnnouncement}
                addText="Add Announcement"
                sortColumn={sortColumn}
                setSortColumn={setSortColumn}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                sortValues={[
                    { value: 'title', label: 'Title'},
                    { value: 'created_on', label: 'Create Date'},
                    { value: 'priority', label: 'Priority'},
                    { value: 'status', label: 'Status'},
                ]}
                allowAdd={IS_MANAGER}
            />
            <BuildAnnouncementTable item={item} />
            <PageNavigation 
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
            />
        </Paper>
        </>
    )
}

export default ViewAnnouncementTable;